import React from "react";
import clone from "lodash/clone";
import axios, {AxiosResponse} from "axios";
import store, {Location, LocationsType, StateType} from "./store";
import {
    addFlights,
    addLocations,
    CodeAndLocationType,
    dequeue,
    enqueue,
    FlightType,
    LocationType,
    LoginType,
    logout,
    NewFlightType,
    removeAllFlights,
    setFlights,
    SettingsType,
    TimeType
} from "./actions/action";
// @ts-ignore
import {climateTexts} from "./Constants";
import {flmVersion} from './version';
import {AircraftType, Airlines, Countries, refreshAirlines} from "./ToolsCached";
import {loginTime} from "./reducers/reducer";
import {DateTime} from "luxon";
import "./loading.css";

declare const Object: any;
declare const google: any;

/*
axios.interceptors.response.use(
    response => response,
    error => {
        console.log('intercep', error);
    }
);
 */


export let analyticsInitialized = false;

const AUTO_LOGOUT_MINUTES = 120;
const AUTO_LOGOUT_NOTICE_MINUTES = 5;
// auto logout
setInterval(() => {
    if (loginTime.time !== -1 && ((loginTime.time + AUTO_LOGOUT_MINUTES*60000) < Date.now())) {
        loginTime.time = -1;
        store.dispatch(logout());
    } else if (loginTime.time !== -1 && ((loginTime.time + (AUTO_LOGOUT_MINUTES - AUTO_LOGOUT_NOTICE_MINUTES)*60000) < Date.now())) {
    }
}, AUTO_LOGOUT_NOTICE_MINUTES*60000);

function getMeasurements() {
    // @ts-ignore
    return document.getElementById('appDiv').getBoundingClientRect();
}



const demoCounter = {
    flights: 0,
    pics: 0
};

//const Loader = () => <div className="loader">Loading...</div>
const Loader = () =>
    <div id="loaderContainer">
        <div id="loaderCircle">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
                 y="0px" width="300px" height="300px" viewBox="0 0 300 300" enableBackground="new 0 0 300 300">
                <defs>
                    <path id="loaderCirclePath" d=" M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "/>
                </defs>
                <circle cx="150" cy="100" r="75" fill="none"/>
                <g>
                    <use xlinkHref="#loaderCirclePath" fill="none"/>
                    <text>
                        <textPath xlinkHref="#loaderCirclePath">Loading images...</textPath>
                    </text>
                </g>
            </svg>
        </div>
    </div>;

const storedVersion = localStorage.getItem('version') || '0';
//this is run before store.js
const seenVersion: string = storedVersion.startsWith('20')
    ? storedVersion
    : '0';
//airline updates break things
if (seenVersion < flmVersion) {
    clearAirlinesCache();
}

export interface AirlineEntryType {
    shortCode: string,
    name: string,
    code: string
}

export interface AircraftEntryType {
    Wake: string,
    family: string,
    ICAO: string,
    IATA: string,
    name: string
}

export interface CountryType {
    country: string,
    flag: string,
    continent: string
}

function clearAirlinesCache() {
    log('clearing airlines cache');
    localStorage.removeItem('Airlines');
    refreshAirlines();
}

function getCountryCodeByCountry(country: any) {
    return Object.values(Countries()).find((countryObject: any) => countryObject.name === country).code;
}

function getCountryByCode(code: string) {
    return Countries()[code.toUpperCase()].name;
}

function getExportData() {
    // @ts-ignore
    const storageItem = {flights: store.getState().reducer.allFlights, locations: store.getState().reducer.locations, pics: store.getState().reducer.pics};
    return JSON.stringify(storageItem);
}

async function callLogin(email: string, password: string): Promise<NullableType<LoginType>> {

    store.dispatch(enqueue('login'));

    const headers = {
        'Content-Type': 'application/json'
    };

    const data = {email, password};

    return axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/login',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then((response: AxiosResponse<LoginType>) => {
            store.dispatch(dequeue('login'));
            log('logged in');
            return response.data;
        })
        .catch(error => {
            store.dispatch(dequeue('login'));
            log('login failed', error);
            return null;
        });
}

async function callReset(password: string): Promise<NullableType<any>> {

    store.dispatch(enqueue('reset'));

    const headers = {
        'Content-Type': 'application/json'
    };

    const token = window.location.search.split('token=')[1];
    const data = {token, password};

    return axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/reset',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then((response: AxiosResponse<LoginType>) => {
            store.dispatch(dequeue('reset'));
            log('resetted');
            return response.data;
        })
        .catch(error => {
            store.dispatch(dequeue('reset'));
            log('reset failed', error);
            return null;
        });
}
async function callRegister(email: string, password: string): Promise<NullableType<LoginType>> {

    store.dispatch(enqueue('register'));

    const headers = {
        'Content-Type': 'application/json'
    };

    const data = {email, password};

    return axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/register',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then((response: AxiosResponse<LoginType>) => {
            store.dispatch(dequeue('register'));
            log('registered');
            return response.data;
        })
        .catch(error => {
            store.dispatch(dequeue('register'));
            log('register failed', error);
            return null;
        });
}
async function callResend(email: string): Promise<NullableType<any>> {

    const headers = {
        'Content-Type': 'application/json'
    };

    const data = {email};

    return axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/sendverification',
        data,
        {
            headers: headers
        }
    )
        .then((response: AxiosResponse<any>) => {
            log('email sent');
            return response.data;
        })
        .catch(error => {
            log('email sending failed', error);
            return null;
        });
}

function getAirportsByCity(city: string, locations: LocationsType) {
    return Object.entries(locations).filter((o: any) => (o[1].city + ', ' + o[1].country) === city).map((o: any) => o[0]);
}


function airportToCityCountry(airport: string, locations: LocationsType) {
    return locations[airport].city + ', ' + locations[airport].country;
}

function airportToCityCountryContinent(airport: string, locations: LocationsType) {
    return locations[airport].city
        + ', '
        + locations[airport].country
        + ', '
        + locations[airport].continent;
}

function cityCountryContinentToLocation(name: string, locations: LocationsType): LocationsType {
    const nameSplit = name.split(', ');
    return Object.values(locations)
        .filter((place: any) => place.continent === nameSplit[2]
            && place.country === nameSplit[1]
            && place.city === nameSplit[0])[0]
}

//TODO check ?

export interface TemperatureChartType {
    destination: string,
    fromMax: number,
    toMax: number,
    average: number
}

function convertTemp(original: number, celsius: boolean) {
    return celsius ? original : Math.ceil(original * 9 / 5 + 32);
}

function convertDistance(original: number, km: boolean) {
    return km ? original : Math.ceil(original / 1.609344);
}

function getDistanceUnit(km: boolean) {
    return km ? 'km' : 'mi';
}


interface EmailContent {
    name: string,
    email: string,
    message: string
}

async function recaptchaCall(data: string): Promise<boolean> {
    const call = axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/recaptcha',
        {'response': data},
        {withCredentials: true}
//        {headers: headers}
    );

    const result: any = await Promise.all([call])
        .then(response => {
            log('recaptcha response from firebase', response);
            if (response[0].data === 'You\'re good to go, human.') {
                return true;
            }
        })
        .catch(error => {
            log('recaptcha firebase call failed', error);
            return false;
        });
    return result;

}

async function sendMail(content: EmailContent): Promise<boolean> {
    const headers = {
        'Content-Type': 'application/json'
    };
    return axios.post<string>('https://flightlogmap-backend.firebaseapp.com/api/v1/sendmail',
        content,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response  => {
            log('send mail ok, data', response.data);
            return response.status === 200;
        })
        .catch(error => {
            log('send mail failed', error);
            return false;
        });
}

interface ImageType {
    url: string,
    description?: string
}

interface GoogleImageSearchResult {
    items: GoogleImageSearchResultItem[]
}
interface GoogleImageSearchResultItem {
    title: string,
    link: string
}

async function saveSettings(settings: SettingsType): Promise<boolean> {
    if (isDemo()) {
        return Promise.resolve(true);
    }
    const headers = {
        'Content-Type': 'application/json'
    };
    return axios.post<string>('https://flightlogmap-backend.firebaseapp.com/api/v1/settings',
        settings,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response  => {
            return response.status === 200;
        })
        .catch(error => {
            log('save settings failed', error);
            return false;
        });
}

async function addAirline(code: string, shortCode: string, name: string): Promise<boolean> {
    const headers = {
        'Content-Type': 'application/json'
    };
    const data = {code, shortCode, name};
    return axios.post<string>('https://flightlogmap-backend.firebaseapp.com/api/v1/airline',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response  => {
            return response.status === 200;
        })
        .catch(error => {
            log('add airline failed', error);
            return false;
        });
}

async function searchImages(query: string): Promise<ImageType[]> {
    const headers = {
        'Content-Type': 'application/json'
    };
    const data = {queryString: query};

    return axios.post<GoogleImageSearchResult>('https://flightlogmap-backend.firebaseapp.com/api/v1/searchgoogle',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response  => {
            return response.data.items.map(item => {
               return {
                   description: item.title,
                   url: item.link
               } ;
            });
        })
        .catch(error => {
            log('searchImages failed', error);
            return [];
        });
}

// type = logo or airplane
async function searchBing(query: string, type: string): Promise<ImageType[]> {
    const headers = {
        'Content-Type': 'application/json'
    };
    const data = {queryString: query, typeString: type};

    return axios.post<any>('https://flightlogmap-backend.firebaseapp.com/api/v1/searchbing',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response  => {
            return response.data.value.map((value: any) => {
                    return {
                        url: value.contentUrl,
                        description: value.name
                    }
                }
            );
        })
        .catch(error => {
            log('searchImages failed', error);
            return [];
        });
}

async function getCityImages(cityAndCountry: string): Promise<ImageType[]> {

    demoCounter.pics = demoCounter.pics + 1;
    log('demo counter city', demoCounter.pics);
    if (isDemo() && (demoCounter.pics > 1)) {
        // @ts-ignore
        return [{'url':store.getState().reducer.pics[cityAndCountry], 'description': cityAndCountry}];
    }

    const city = cityAndCountry.split(',').join(' ');
    let results: ImageType[] = [];

    store.dispatch(enqueue("getCityImages_" + cityAndCountry));

    try {
        const images: ImageType[][] = [];
        images[0] = await searchImages(city + ' flickr landmark');
        images[1] = await searchImages(city + ' beautiful skyline');
        images[2] = await searchImages(city + ' beautiful scenery');
        images[3] = await searchImages(city + ' beautiful sights');

        results = results.concat(...images);

        store.dispatch(dequeue("getCityImages_" + cityAndCountry));
    } catch (error) {
        //TODO show error
        store.dispatch(dequeue("getCityImages_" + cityAndCountry));
    }

    return results;
}

async function getAirlineImages(name: string): Promise<ImageType[]> {

    demoCounter.pics = demoCounter.pics + 1;
    log('demo counter airline', demoCounter.pics);
    if (isDemo() && (demoCounter.pics > 1)) {
        // @ts-ignore
        return [{'url':store.getState().reducer.pics[name], 'description': name}];
    }

    let results: ImageType[] = [];

    const spinnerKey = "getAirlineImages_" + name;

    store.dispatch(enqueue(spinnerKey));

    try {
        const images: ImageType[][] = [];
        images[0] = await searchImages(name + ' official corporate logo');
        images[1] = await searchImages(name + ' logo picture name');

        const bingImages = await searchBing(name, 'logo');

        results = [...bingImages, ...images[0], ...images[1]];

        store.dispatch(dequeue(spinnerKey));
    } catch (error) {
        //TODO show error
        store.dispatch(dequeue(spinnerKey));
    }

    return results;
}

async function getPlaneImages(planeName: string): Promise<ImageType[]> {

    demoCounter.pics = demoCounter.pics + 1;
    log('demo counter plane', demoCounter.pics);
    if (isDemo() && (demoCounter.pics > 1)) {
        // @ts-ignore
        return [{'url':store.getState().reducer.pics[planeName], 'description': planeName}];
    }

    const nameArray: string[] = planeName.split(',');
    const queryArray: string[] = [];
    let airline = false;
    let noModel = false;
    let noPlane = false;
    if (nameArray[0] && nameArray[0] !== 'null' && nameArray[0] !== 'undefined') {
        queryArray.push(Airlines()[nameArray[0]].name);
        airline = true;
    }
    if (nameArray[1] && nameArray[1] !== 'null' && nameArray[1] !== 'undefined') {
        queryArray.push(nameArray[1]);
    } else {
        noModel = true;
    }
    if (nameArray[2] && nameArray[2] !== 'null' && nameArray[2] !== 'undefined') {
        queryArray.push(nameArray[2].split('_')[0]);
    } else {
        noPlane = true;
    }
    const query = queryArray.join(' ') + ((airline && noModel && noPlane) ? ' tail logo' : '');

    let results: ImageType[] = [];

    store.dispatch(enqueue("getPlaneImages" + planeName));

    try {
        const images: ImageType[][] = [];

        //images[0] = await searchImages(query + ' flickr');
        images[1] = await searchImages(query + ' airplane pictures');

        const bingImages = await searchBing(query, 'airplane');

        results = [...bingImages, ...images[1]];

        store.dispatch(dequeue("getPlaneImages" + planeName));
    } catch (error) {
        //TODO show error
        store.dispatch(dequeue("getPlaneImages" + planeName));
    }
    return results;
}

function normalizeFlight(flight: FlightType, locations: LocationsType): FlightType {
    // @ts-ignore
    const homeAirport = store.getState().reducer.user.homeAirport;
    const normalizedFlight = clone(flight);
    if (flight.to === homeAirport || (flight.from !== homeAirport && (locations[flight.to].city < locations[flight.from].city))) {
        normalizedFlight.from = flight.to;
        normalizedFlight.fromTemp = flight.toTemp;
        normalizedFlight.to = flight.from;
        normalizedFlight.toTemp = flight.fromTemp;
        normalizedFlight.normalized = true;
    }
    return normalizedFlight;
}

function getClimateByCity(city: string, locations: LocationsType) {
    const matchingLocations: Location[] = Object.values(locations).filter((location: LocationType) => location.city === city);
    const climateMatches = matchingLocations.filter(matchingLocation => matchingLocation.climate?.length > 0).map(location => location.climate);
    // @ts-ignore
    return (climateMatches.length === 0) ? 'N/A' : [...new Set(climateMatches.map(climateCode => getClimateText(climateCode)))].join(',');
}

function getClimateText(climateCode: string) {
    return Object.entries(climateTexts).find((entry: any) => climateCode.startsWith(entry[0]))[1];
}


export type NullableType<T> = T | null | undefined;



function getAirports(flights: FlightType[]): string[] {
    const airports: string[] = [];
    flights.forEach(flight => {
        airports.push(flight.from);
        airports.push(flight.to);
    });
    return airports.sort();
}

function getAirlines(flights: any[]) {
    return flights.map(flight => flight.airline).filter(n => n).sort();
}

function getModels(flights: any[]) {
    return flights.map(flight => flight.model ? flight.model.split('_')[0] : null).filter(n => n).sort();
}

function getFlightsByRoute(flights: any[], inputFlight: FlightType, locations: LocationsType) {
    const retval = flights.filter(flight => {
        const normalizedFlight = normalizeFlight(flight, locations);
        const normalizedInputFlight = normalizeFlight(inputFlight, locations);
        return (normalizedFlight.from === normalizedInputFlight.from
            && normalizedFlight.to === normalizedInputFlight.to);
    });
    return retval;
}

function getBasicNameByModelName(name: string, aircrafts: AircraftType) {
    const model = Object.values(aircrafts).find((o: any) => o.name === name);
    return Object.values(aircrafts).find((o: any) => o.family === model.family && o.basic).name;
}

// TODO function type?
export interface ConfirmType {
    text: string,
    confirmedFunction: any
}
export interface ChangingImageType {
    airline: AirlineEntryType,
    position: number,
    images: ImageType[]
}

export interface FormState {
    tripValue: NullableType<string>,
    tripInputValue: string,
    tripOptions: string[],
    fromAirportValue: NullableType<string>,
    fromAirportInputValue: string,
    fromAirportOptions: string[],
    toAirportValue: NullableType<string>,
    toAirportInputValue: string,
    toAirportOptions: string[],
    airlineValue: NullableType<string>,
    airlineInputValue: string,
    airlineOptions: string[],
    modelValue: NullableType<string>,
    modelInputValue: string,
    modelOptions: string[],

    id: number,
    date: NullableType<DateTime>,
    seat: string,
    leg: string,
    class: string,
    purpose: string,
    hour: string,
    minute: string,
    trip: string,
    business: boolean,
    noDay: boolean,
    noYear: boolean,
    fromAirport: NullableType<string>,
    fromAirportSuggestions: any[],
    toAirport: NullableType<string>,
    toAirportSuggestions: any[],
    plane: string,
    code: string,
    comment: string,
    airline: NullableType<string>,
    airlineSuggestions: any[],
    model: NullableType<string>,
    modelSuggestions: any[],
    storeInProgress: boolean,
    dirty?: boolean,
    dirtyFlights?: boolean,
    departure: NullableType<DateTime>,
    arrival: NullableType<DateTime>,
    changingImage?: ChangingImageType,
    tripHelp: string,
    tab: string,
    invalid?: boolean,
    confirm?: ConfirmType
}

function basicEncrypt(plainText: string, rotate: number) {
    rotate = rotate % 255; // rotate should not be greater than 255 or less than -255.
    let cipherText = '';
    for (let i = 0; i < plainText.length; i++) {
        cipherText += String.fromCharCode((plainText.charCodeAt(i) + rotate + 255) % 255); // Rotate all characters.
    }
    return cipherText;
}


//async function fillFlightDetails


async function GeocodeAddress(iata: string): Promise<CodeAndLocationType> {

    log('geocode address', iata);
    try {
        const array = await searchAirport(iata.toLowerCase());
        const airport = array[0];
        const climate = await getClimate(airport.lat, airport.lng);
        const details: LocationType = {
            city: airport.city,
            country: getCountryByCode(airport.country),
            lat: airport.lat,
            lng: airport.lng,
            continent: airport.continent, //getContinent(new google.maps.LatLng(airport.lat, airport.lng)),
            airportName: airport.name,
            icao: airport.icao,
            climate
        };
        return {
            code: iata,
            details: details
        };
    } catch (error) {
        log('geocodeaddress failed for ' + iata, error);
        throw error;
    }
}

function getContinent(latLng: any): string {
    let retval = '';
    continents.forEach(o => {
        var polygon = new google.maps.Polygon({
            paths: o.coords
        });
        if (google.maps.geometry.poly.containsLocation(latLng, polygon)) {
            retval = o.name;
            return false;
        }
    });
    if (!retval) {
        log('no continent found for ', latLng);
        throw new Error('Continent missing');
    } else {
        return retval;
    }
}

function getContinentCodes() {
    return ['na','sa','eu','af','as','oc'];
    //return continents.map(continent => continent.name);
}

function getContinentNameFromCode(code: string): string {
    const continentName: any = {
        'na': 'north america',
        'sa': 'south america',
        'af': 'africa',
        'as': 'asia',
        'oc': 'oceania',
        'eu': 'europe',
    };
    return continentName[code];
}

interface CoordinateType {
    lat: number,
    lng: number
}

interface ContinentType {
    name: string,
    coords: CoordinateType[]
}

const continents: ContinentType[] = [{
    name: 'northamerica',
    coords: [
        {lat: 32.06396, lng: -117.77344},
        {lat: 25.6019, lng: -96.85547},
        {lat: 23.96618, lng: -79.7168},
        {lat: 30.33495, lng: -79.32129},
        {lat: 48.0687, lng: -49.41268},
        {lat: 68.86988, lng: -62.35008},
        {lat: 75.35823, lng: -77.8091},
        {lat: 71.49983, lng: -169.83105},
        {lat: 51.26191, lng: -167.25586},
        {lat: 32.06396, lng: -117.77344}
    ]
}, {
    name: 'europe',
    coords: [
        {lat: 74.02559, lng: 1.09863},
        {lat: 65.20147, lng: -28.54248},
        {lat: 35.11991, lng: -10.41504},
        {lat: 38.42777, lng: 8.85498},
        {lat: 32.2474, lng: 26.20622},
        {lat: 38.81923, lng: 34.35158},
        {lat: 45.76553, lng: 43.35912},
        {lat: 52.26009, lng: 49.68677},
        {lat: 69.11561, lng: 53.74512},
        {lat: 74.02559, lng: 1.09863}
    ]
}, {
    name: 'africa',
    coords: [
        {lat: -50.2753, lng: 28.16895},
        {lat: 8.01572, lng: -34.51904},
        {lat: 33.2295, lng: -32.12402},
        {lat: 37.73597, lng: 9.95361},
        {lat: 31.46356, lng: 32.79801},
        {lat: 12.164, lng: 43.5801},
        {lat: 13.92064, lng: 62.739},
        {lat: -21.79215, lng: 71.39575},
        {lat: -44.87144, lng: 75.19043},
        {lat: -50.2753, lng: 28.16895}
    ]
}, {
    name: 'southamerica',
    coords: [
        {lat: 6.24978, lng: -77.87109},
        {lat: 8.83512, lng: -76.9506},
        {lat: 10.9675, lng: -75.33785},
        {lat: 12.52239, lng: -71.69678},
        {lat: 12.30835, lng: -69.83389},
        {lat: 10.6822, lng: -67.56592},
        {lat: 10.75968, lng: -66.03258},
        {lat: 10.74697, lng: -63.62183},
        {lat: 10.86163, lng: -61.79194},
        {lat: 10.13112, lng: -62.12769},
        {lat: 9.86063, lng: -61.76514},
        {lat: 9.93639, lng: -61.30371},
        {lat: 4.47786, lng: -50.47119},
        {lat: -1.81244, lng: -43.75854},
        {lat: -3.74367, lng: -34.33228},
        {lat: -10.1203, lng: -34.68384},
        {lat: -24.30705, lng: -41.44043},
        {lat: -50.15294, lng: -66.46393},
        {lat: -55.11608, lng: -63.03955},
        {lat: -56.65309, lng: -68.29095},
        {lat: -53.58247, lng: -76.26498},
        {lat: -2.94711, lng: -82.61216},
        {lat: 2.28455, lng: -81.47461},
        {lat: 6.24978, lng: -77.87109}
    ]
}, {
    name: 'caribbean',
    coords: [
        {lat: 28.63275, lng: -79.40918},
        {lat: 24.80668, lng: -79.51904},
        {lat: 22.73566, lng: -84.8584},
        {lat: 14.56232, lng: -82.06787},
        {lat: 10.52802, lng: -83.0638},
        {lat: 12.50745, lng: -71.64451},
        {lat: 11.30491, lng: -65.6692},
        {lat: 9.78269, lng: -61.05542},
        {lat: 17.18278, lng: -53.12988},
        {lat: 28.63275, lng: -79.40918}
    ]
}, {
    name: 'centralamerica',
    coords: [
        {lat: 32.06396, lng: -117.77344},
        {lat: 25.6019, lng: -96.85547},
        {lat: 22.02455, lng: -85.3418},
        {lat: 14.56232, lng: -82.06787},
        {lat: 11.12152, lng: -82.92098},
        {lat: 9.22798, lng: -76.84104},
        {lat: 5.53661, lng: -78.41334},
        {lat: 12.39151, lng: -98.26611},
        {lat: 24.32708, lng: -121.20117},
        {lat: 32.06396, lng: -117.77344}
    ]
}, {
    name: 'asia',
    coords: [
        {lat: 13.88075, lng: 53.34961},
        {lat: 12.12831, lng: 43.7431},
        {lat: 23.0393, lng: 36.82617},
        {lat: 32.26507, lng: 30.95211},
        {lat: 39.67221, lng: 25.16529},
        {lat: 40.68064, lng: 27.86133},
        {lat: 42.94034, lng: 35.90332},
        {lat: 41.67291, lng: 50.00977},
        {lat: 73.33612, lng: 66.88078},
        {lat: 78.08016, lng: 93.2959},
        {lat: 77.50412, lng: 116.45508},
        {lat: 75.51915, lng: 155.78613},
        {lat: 71.77394, lng: -175.56152},
        {lat: 65.80463, lng: -168.99108},
        {lat: 62.96362, lng: -174.14075},
        {lat: 49.06736, lng: 158.02851},
        {lat: 34.05266, lng: 149.15039},
        {lat: 1.80146, lng: 126.69434},
        {lat: -7.05728, lng: 123.88184},
        {lat: -12.03932, lng: 121.20117},
        {lat: -7.36774, lng: 97.97955},
        {lat: 6.29082, lng: 77.20267},
        {lat: 13.88075, lng: 53.34961}
    ]
}, {
    name: 'oceania',
    coords: [
        {lat: 51.06902, lng: -173.32031},
        {lat: 49.33211, lng: -137.07463},
        {lat: 19.06212, lng: -118.91602},
        {lat: 0.87887, lng: -95.53711},
        {lat: -43.83453, lng: -84.02344},
        {lat: -68.52823, lng: -90.9668},
        {lat: -69.74855, lng: -177.53906},
        {lat: -58.21702, lng: 109.59961},
        {lat: -16.42254, lng: 114.16719},
        {lat: 17.20527, lng: 148.79746},
        {lat: 51.06902, lng: -173.32031}
    ]
}

];

export interface AirportSearchResultType {
    city: string,
    continent: string,
    country: string,
    elev: number,
    iata: string,
    icao: string,
    lat: number,
    lng: number,
    name: string,
    region: string,
    type: string
}


async function resetPassword(email: string) {
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        const data = {email};
        await axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/sendreset',
            data,
            {
                withCredentials: true,
                headers
            });
    } catch (error) {
    }
}

async function searchAirport(text: string): Promise<AirportSearchResultType[]> {
    try {
        const result = await axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/airports?text=' + text,
            {withCredentials: true});
        return result.data as AirportSearchResultType[];
    } catch (error) {
        log('searchAirport failed', error);
        return [];
    }
}

async function getClimate(lat: number, lng: number) {
    try {
        const latQuery = convertLatLngValueToClimateQueryValue(lat);
        const lngQuery = convertLatLngValueToClimateQueryValue(lng);
        const result = await axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/climate?lat=' + latQuery
            + '&lng=' + lngQuery,
            {withCredentials: true});
        return result.data.climate;
    } catch (error) {
        log('getClimate failed', error);
    }
}

function convertLatLngValueToClimateQueryValue(value: number): number {
    const numberString = '' + value;
    if (numberString.indexOf('.') > -1) {
        const integerPart = numberString.split('.')[0];
        const rightPart = Number(numberString.split('.')[1].substring(0,2));
        if (Number(integerPart) >= 0) {
            return Number(integerPart) + (rightPart > 50 ? 0.75 : 0.25);
        } else {
            return Number(integerPart) - (rightPart > 50 ? 0.75 : 0.25);
        }
    } else {
        if (value >= 0) {
            return value + 0.25;
        } else {
            return value - 0.25;
        }
    }
}


export type StoreType = 'delete' | 'add' | 'edit';



function sortAndSetFlights() {
    // @ts-ignore
    store.dispatch(setFlights(sortFlights(store.getState().reducer.allFlights, true)));
}


//input array [flights, locations, pics, newflights]
async function getUserData(values: any) {
    // @ts-ignore
    const user: any = store.getState().reducer.user;
    if (!values[0].data) {
        log('getUserData: no data found for user ' + user.email);
    } else {

        values[0].data.flights = JSON.parse(basicEncrypt(values[0].data.flights, -108));

        store.dispatch(addLocations(values[1].data));
        if (!values[0].data.flights) {
            log('getUserData: no flights yet');
        } else {
            //data conversions between data model versions
            values[0].data.flights.forEach((flight: FlightType) => {
                //temporary measure until 3-char airline codes are fully in use
                if (flight.airline && flight.airline.length === 2) {
                    flight.airline = Object.values(Airlines())
                        .find((airline: AirlineEntryType) => airline.shortCode === flight.airline).code;
                }
                //temporary measure business field is fully in use
                if (typeof flight.business === 'undefined') {
                    flight.business = false;
                }
                //temporary measure unit hour field is fully in use
                if (typeof flight.hour === 'undefined') {
                    flight.hour = '';
                }
                //temporary measure unit hour field is fully in use
                if (typeof flight.minute === 'undefined') {
                    flight.minute = '';
                }
                //temporary measure until all datetimes are dates
                if (flight.date.indexOf('T') > -1) {
                    flight.date = flight.date.split('T')[0];
                }
            });

            store.dispatch(addFlights(values[0].data.flights));
        }
    }
    store.dispatch(dequeue("getUserData"));

}


async function logoutBackend() {
    try {
        const retval = await axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/logout',
            {withCredentials: true}
        );
        axios.defaults.headers.common['Authorization'] = '';
        return retval;
    } catch(error: any) {
        axios.defaults.headers.common['Authorization'] = '';
        return error.response;
    }
}

function getUserDataFromBackend(token: string) {
    store.dispatch(enqueue("getUserData"));
    axios.defaults.headers.common['Authorization'] = token;

    const flights2 = axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/getshareflightse',
        {withCredentials: true}
    );
    const locations2 = axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/getsharelocations',
        {withCredentials: true}
    );
    Promise.all([flights2, locations2])
        .then(values => {
            getUserData(values);
            store.dispatch(dequeue("getUserData"));
        })
        .catch(error => {
            log("getUserData retry failed", error);
            store.dispatch(dequeue("getUserData"));
        });
}

function getAllFlightsLength() {
    // @ts-ignore
    return store.getState().reducer.allFlights.length;
}

function getLocations() {
    // @ts-ignore
    return store.getState().reducer.locations;
}

function getUserDataFromSaveFile(savedData: any) {
    store.dispatch(removeAllFlights());
    getUserData([
        {data: {flights: basicEncrypt(JSON.stringify(savedData.flights), 108)}},
        {data: savedData.locations},
        {data: savedData.pics},
        {data: {newflights: []}}
    ]);
}




// if no departure/arrival time, use midnight as default

function estimateDuration(distance: number) {
    return Math.round((distance / 13.333) + 25);
}

function hoursFromTotalMinutes(minutes: number) {
    return parseInt('' + (minutes / 60), 10);
}

function minutesFromTotalMinutes(minutes: number) {
    return parseInt('' + minutes % 60, 10);
}

const noTemp: DailyWeather = {
    max: -300,
    min: -300
};

export interface DailyWeather {
    max: number,
    min: number
}

export interface WeatherResponse {
    queryCost: number;
    latitude: number;
    longitude: number;
    resolvedAddress: string;
    address: string;
    timezone: string;
    tzoffset: number;
    days: WeatherResponseDay[];
    stations: any;
}

export interface WeatherResponseDay {
    datetime: string;
    datetimeEpoch: number;
    tempmax: number;
    tempmin: number;
    temp: number;
    feelslikemax: number;
    feelslikemin: number;
    feelslike: number;
    dew: number;
    humidity: number;
    precip: number;
    precipprob: number;
    precipcover: number;
    preciptype: string[];
    snow: number;
    snowdepth: number;
    windgust: number;
    windspeed: number;
    winddir: number;
    pressure: number;
    cloudcover: number;
    visibility: number;
    solarradiation: number;
    solarenergy: number;
    uvindex: number;
    sunrise: string;
    sunriseEpoch: number;
    sunset: string;
    sunsetEpoch: number;
    moonphase: number;
    conditions: string;
    description: string;
    icon: string;
    stations: string[];
    source: string;
}

async function countUsers() {
    const headers = {
        'Content-Type': 'application/json'
    };
    const response: AxiosResponse<any> = await axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/usercount',
        {},
        {
            withCredentials: true,
            headers: headers
        });

    return response.data.users;

}

async function getTemp(iata: string, date: string, noDay: boolean, noYear: boolean): Promise<DailyWeather> {

    //TODO rename to icao
    // @ts-ignore
    const location = store.getState().reducer.locations[iata];

    let resultTemperature: DailyWeather;

    if (noDay) {
        resultTemperature = noTemp;
    } else {

        //TODO cleanup redundant
        const formattedDate = date;
        // @ts-ignore
        const existingFrom = store.getState().reducer.allFlights.filter(
            (flight: FlightType) => flight.date.split('T')[0] === formattedDate && flight.from === iata);
        if (existingFrom.length && existingFrom[0].fromTemp.max > -300) {
            log('found existing temp for:', iata, formattedDate, existingFrom[0].fromTemp);
            return existingFrom[0].fromTemp;
        }
        // @ts-ignore
        const existingTo = store.getState().reducer.allFlights.filter(
            (flight: FlightType) => flight.date.split('T')[0] === formattedDate && flight.to === iata);
        if (existingTo.length && existingTo[0].toTemp.max > -300) {
            log('found existing temp for:', iata, formattedDate, existingTo[0].toTemp);
            return existingTo[0].toTemp;
        }

        store.dispatch(enqueue("getTemp_" + location.city));

        try {

            const headers = {
                'Content-Type': 'application/json'
            };
            // yyyymmdd
            const data = {lat: location.lat, lng: location.lng, date: formattedDate.replace(/-/g, '')};

            const response: AxiosResponse<WeatherResponse> = await axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/weather',
                data,
                {
                    withCredentials: true,
                    headers: headers
                });

            store.dispatch(dequeue("getTemp_" + location.city));

            const weather = response.data;

            resultTemperature = {
                max: Math.round(weather.days[0].tempmax),
                min: Math.round(weather.days[0].tempmin)
            };

        } catch (error) {
            store.dispatch(dequeue("getTemp_" + location.city));
            resultTemperature = noTemp;
        }
    }
    return resultTemperature;
}

function toAirportCity(locations: LocationsType) {
    return (code: string) => {
        return locations[code].city;
    }
}

function toAirportCityCountry(locations: LocationsType) {
    return (code: string) => {
        return [locations[code].city, locations[code].country.toLowerCase()].join(',');
    }
}

function toAirportName(locations: LocationsType) {
    return (code: string) => {
        return locations[code].airportName;
    }
}

function hasMultipleAirports(locations: LocationsType) {
    return (code: string) => {
        const city = locations[code].city;
        const found = Object.entries(locations).filter((location: any) => location[1].city === city).length;
        return found > 1;
    }
}

function getPlanePicKey(flight: FlightType) {
    return '' + flight.airline + ',' + flight.plane + ',' + flight.model;
}

/*
interface TimeZoneResponseType {
    dstOffset: number,
    rawOffset: number,
    timeZoneId: string,
    timeZoneName: string,
    status: string,
    errorMessage?: string
}
*/


function parseTimeType(text: string | undefined): NullableType<TimeType> {
    if (!text) {
        return null;
    }
    try {
        const hour = Number(text.split(':')[0]);
        const minute = Number(text.split(':')[1]);
        if (isNaN(hour) || isNaN(minute) || hour < 0 || minute < 0 || hour > 23 || minute > 59) {
            return null;
        }
        return {
            hour,
            minute
        };
    } catch (ex) {
        return null;
    }
}

function timeTypeToString(time: NullableType<TimeType>): string {
    if (!time) {
        // &nbsp;
        return '\xa0';
    }
    return time.hour.toString(10).padStart(2, '0')
        + ':'
        + time.minute.toString(10).padStart(2, '0');
}

function timeStringToTimeType(time: NullableType<DateTime>): NullableType<TimeType> {
    if (!time) {
        return null;
    }
    return {
        hour: Number(time.get('hour')),
        minute: Number(time.get('minute'))
    };
}

function timeStringToTimePickerValue(time: string): DateTime {
    const timeSplit = time.split(':');
    const now = new Date();
    const retval = DateTime.local(now.getFullYear(), now.getMonth()+1, now.getDate(), Number(timeSplit[0]), Number(timeSplit[1]));
    return retval;
}

const timezoneDetailCache: any = {};

async function fillCacheWithTimezones(locations: LocationsType) {
    const headers = {
        'Content-Type': 'application/json'
    };

    const data = {locations: Object.values(locations).map((location: Location) => {
        return {
            lat:location.lat,
            lng:location.lng
        };
    })};

    return axios.post('https://flightlogmap-backend.firebaseapp.com/api/v1/timezones',
        data,
        {
            withCredentials: true,
            headers: headers
        }
    )
        .then(response => {
            response.data.retval.forEach((location: any) => {
                const cacheKey = '' + location.lat + '_' +location.lng;
                timezoneDetailCache[cacheKey] = getStringFromArrayOrString(location.timezone);
            });
            log('filled timezone cache with', response.data.retval.length);
            return true;
        })
        .catch(error => {
            log('timezone cache fill failed', error);
            return false;
        });

}

function getCachedTimezoneName(iata: string, state: StateType) {
    const lat = state.locations[iata].lat;
    const lng = state.locations[iata].lng;
    const cacheKey = '' + lat + '_' + lng;
    return timezoneDetailCache[cacheKey];
}

function getMobileHeightForTable() {
    const fraction = 0.9;
    // eslint-disable-next-line no-restricted-globals
    const innerHeight = window.innerHeight;
    return fraction * innerHeight;
}

function getStringFromArrayOrString(value: (string[] | string)): string {
    if (typeof value === 'string') {
        return value;
    } else {
        if (value.length) {
            return value[0];
        } else {
            return '';
        }
    }
}

function isDemo() {
    // @ts-ignore
    return store.getState().reducer.user?.email === 'demo' && !store.getState().reducer.user?.isSuper;
}

function userLevelAtLeast(level: LevelType): boolean {
    return (userLevelNumber() >= levelNumber(level));
}

function isFreeUser(): boolean {
    return (userLevelNumber() === 1);
}

function userLevelAtLeastPure(level: LevelType, user: LoginType): boolean {
    return (userLevelNumberPure(user) >= levelNumber(level));
}

export type LevelType = 'unverified' | 'free' | 'silver' | 'gold' | 'platinum' | 'super';

/////// KEEP IN SYNC WITH BACKEND!!! START //////////////////////
function levelNumber(level: LevelType) {
    switch (level) {
        case 'unverified': return 0;
        case 'free': return 1;
        case 'silver': return 2;
        case 'gold': return 3;
        case 'platinum': return 4;
        case 'super': return 9;
    }
    return -1;
}

function userLevelNumberPure(user: LoginType): number {
    if (!user) {return -1;}
    if (user.isSuper) {return 9;}
    if (user.email === 'demo') {return 4;}
    switch (user.level) {
        case 'unverified': return 0;
        case 'free': return 1;
        case 'silver': return 2;
        case 'gold': return 3;
        case 'platinum': return 4;
    }
    return -1;
}

function userLevelNumber(): number {
    // @ts-ignore
    const user = store.getState().reducer.user;
    if (!user) {
        return -1;
    }
    return userLevelNumberPure(user);
}

/////// KEEP IN SYNC WITH BACKEND!!! END //////////////////////

async function getTimezoneName(iata: string) {
    try {
        // @ts-ignore
        const lat = store.getState().reducer.locations[iata].lat;
        // @ts-ignore
        const lng = store.getState().reducer.locations[iata].lng;

        const cacheKey = '' + lat + '_' + lng;
        if(!timezoneDetailCache[cacheKey]) {
            const result = await axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/timezone?lat=' + lat
                + '&lng=' + lng,
                {withCredentials: true});
            const value = getStringFromArrayOrString(result.data.timezone);
            timezoneDetailCache[cacheKey] = value;
            return value;
        } else {
            return timezoneDetailCache[cacheKey];
        }

    } catch (error) {
        log('getTimezoneName failed', error);
    }
}

function checkEmail(email: string) {
    /* eslint-disable no-useless-escape */
    const emailCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailCheck.test(email);
}

function checkPassword(password: string) {
    const ascii = /^[ -~]+$/;

    if ( !ascii.test(password) ) {
       return 'Only regular ascii characters allowed in password';
    }

    const decimal=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/;
    if(!password.match(decimal)) {
        return 'Password must be 8 to 16 characters long and contain a lowercase letter, an uppercase letter, a digit and a special character';
    }
    return '';
}

/*
function getTimeZone(iata: string, timestamp: number): Promise<TimeZoneResponseType> {

    // @ts-ignore
    const lat = store.getState().reducer.locations[iata].lat;
    // @ts-ignore
    const lng = store.getState().reducer.locations[iata].lng;

    return new Promise(function (resolve, reject) {

        store.dispatch(enqueue("getTimeZone_" + timestamp));

        // @ts-ignore
        const user: any = store.getState().reducer.user;

        const headers = {
            'Content-Type': 'application/json'
        };
        const data = {email: user.email, password: user.password, lat, lng, timestamp};

        axios.post<any>('https://flightlogmap-backend.firebaseapp.com/api/v1/searchtimezone',
            data,
            {headers: headers}
        )
            .then(response => {

                    store.dispatch(dequeue("getTimeZone_" + timestamp));

                    resolve(response.data);
                }
                //TODO add error handling
            );

    });
}
*/
//////////////////////////////////////////////////

export const D2R = Math.PI / 180;
export const R2D = 180 / Math.PI;

export class Coord {
    lon: number;
    lat: number;
    x: number;
    y: number;

    constructor(lon: number, lat: number) {
        this.lon = lon;
        this.lat = lat;
        this.x = D2R * lon;
        this.y = D2R * lat;
    }

    view() {
        return String(this.lon).slice(0, 4) + ',' + String(this.lat).slice(0, 4);
    };

    antipode() {
        var anti_lat = -1 * this.lat;
        var anti_lon = (this.lon < 0) ? 180 + this.lon : (180 - this.lon) * -1;
        return new Coord(anti_lon, anti_lat);
    };

}


export class LineString {
    coords: any[];
    length;

    constructor() {
        this.coords = [];
        this.length = 0;
    }

    move_to(coord: any) {
        this.length++;
        this.coords.push(coord);
    };
}
;


export class Arc {
    properties: any;
    geometries: any;

    constructor(properties: any) {
        this.properties = properties || {};
        this.geometries = [];
    }

    json() {
        if (this.geometries.length <= 0) {
            return {
                'geometry': {'type': 'LineString', 'coordinates': null},
                'type': 'Feature', 'properties': this.properties
            };
        } else if (this.geometries.length === 1) {
            return {
                'geometry': {'type': 'LineString', 'coordinates': this.geometries[0].coords},
                'type': 'Feature', 'properties': this.properties
            };
        } else {
            var multiline: any = [];
            for (var i = 0; i < this.geometries.length; i++) {
                multiline.push(this.geometries[i].coords);
            }
            return {
                'geometry': {'type': 'MultiLineString', 'coordinates': multiline},
                'type': 'Feature', 'properties': this.properties
            };
        }
    };

// TODO - output proper multilinestring
    wkt() {
        var wkt_string = '';
        var wkt = 'LINESTRING(';
        var collect = function (c: any) {
            wkt += c[0] + ' ' + c[1] + ',';
        };
        for (var i = 0; i < this.geometries.length; i++) {
            if (this.geometries[i].coords.length === 0) {
                return 'LINESTRING(empty)';
            } else {
                var coords = this.geometries[i].coords;
                coords.forEach(collect);
                wkt_string += wkt.substring(0, wkt.length - 1) + ')';
            }
        }
        return wkt_string;
    };

}
;


/*
 * http://en.wikipedia.org/wiki/Great-circle_distance
 *
 */
class GreatCircle {

    start: Coord;
    end: Coord;
    properties: any;
    g;

    constructor(start: Coord, end: Coord, properties: {}) {
        if (!start || start.x === undefined || start.y === undefined) {
            throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
        }
        if (!end || end.x === undefined || end.y === undefined) {
            throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
        }
        this.start = new Coord(start.x, start.y);
        this.end = new Coord(end.x, end.y);
        this.properties = properties || {};

        var w = this.start.x - this.end.x;
        var h = this.start.y - this.end.y;
        var z = Math.pow(Math.sin(h / 2.0), 2) +
            Math.cos(this.start.y) *
            Math.cos(this.end.y) *
            Math.pow(Math.sin(w / 2.0), 2);
        this.g = 2.0 * Math.asin(Math.sqrt(z));

        if (this.g === Math.PI) {
            throw new Error('it appears ' + start.view() + ' and ' + end.view() + " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");
        } else if (isNaN(this.g)) {
            throw new Error('could not calculate great circle between ' + start + ' and ' + end);
        }
    };

    /*
     * http://williams.best.vwh.net/avform.htm#Intermediate
     */
    interpolate(f: number) {
        var A = Math.sin((1 - f) * this.g) / Math.sin(this.g);
        var B = Math.sin(f * this.g) / Math.sin(this.g);
        var x = A * Math.cos(this.start.y) * Math.cos(this.start.x) + B * Math.cos(this.end.y) * Math.cos(this.end.x);
        var y = A * Math.cos(this.start.y) * Math.sin(this.start.x) + B * Math.cos(this.end.y) * Math.sin(this.end.x);
        var z = A * Math.sin(this.start.y) + B * Math.sin(this.end.y);
        var lat = R2D * Math.atan2(z, Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)));
        var lon = R2D * Math.atan2(y, x);
        return [lon, lat];
    };

    /*
     * Generate points along the great circle
     */
    Arc(npoints: number, options: any) {
        var first_pass: any = [];
        if (!npoints || npoints <= 2) {
            first_pass.push([this.start.lon, this.start.lat]);
            first_pass.push([this.end.lon, this.end.lat]);
        } else {
            var delta = 1.0 / (npoints - 1);
            for (var i = 0; i < npoints; ++i) {
                var step = delta * i;
                var pair = this.interpolate(step);
                first_pass.push(pair);
            }
        }
        /* partial port of dateline handling from:
         gdal/ogr/ogrgeometryfactory.cpp

         TODO - does not handle all wrapping scenarios yet
         */
        var bHasBigDiff = false;
        var dfMaxSmallDiffLong = 0;
        // from http://www.gdal.org/ogr2ogr.html
        // -datelineoffset:
        // (starting with GDAL 1.10) offset from dateline in degrees (default long. = +/- 10deg, geometries within 170deg to -170deg will be splited)
        var dfDateLineOffset = 1;
        var dfLeftBorderX = 180 - dfDateLineOffset;
        var dfRightBorderX = -180 + dfDateLineOffset;
        var dfDiffSpace = 360 - dfDateLineOffset;

        // https://github.com/OSGeo/gdal/blob/7bfb9c452a59aac958bff0c8386b891edf8154ca/gdal/ogr/ogrgeometryfactory.cpp#L2342
        for (var j = 1; j < first_pass.length; ++j) {
            var dfPrevX = first_pass[j - 1][0];
            var dfX = first_pass[j][0];
            var dfDiffLong = Math.abs(dfX - dfPrevX);
            if (dfDiffLong > dfDiffSpace &&
                ((dfX > dfLeftBorderX && dfPrevX < dfRightBorderX) || (dfPrevX > dfLeftBorderX && dfX < dfRightBorderX))) {
                bHasBigDiff = true;
            } else if (dfDiffLong > dfMaxSmallDiffLong) {
                dfMaxSmallDiffLong = dfDiffLong;
            }
        }

        var poMulti: any = [];
        if (bHasBigDiff && dfMaxSmallDiffLong < dfDateLineOffset) {
            var poNewLS: any = [];
            poMulti.push(poNewLS);
            for (var k = 0; k < first_pass.length; ++k) {
                var dfX0 = parseFloat(first_pass[k][0]);
                if (k > 0 && Math.abs(dfX0 - first_pass[k - 1][0]) > dfDiffSpace) {
                    var dfX1 = parseFloat(first_pass[k - 1][0]);
                    var dfY1 = parseFloat(first_pass[k - 1][1]);
                    var dfX2 = parseFloat(first_pass[k][0]);
                    var dfY2 = parseFloat(first_pass[k][1]);
                    if (dfX1 > -180 && dfX1 < dfRightBorderX && dfX2 === 180 &&
                        k + 1 < first_pass.length &&
                        first_pass[k - 1][0] > -180 && first_pass[k - 1][0] < dfRightBorderX) {
                        poNewLS.push([-180, first_pass[k][1]]);
                        k++;
                        poNewLS.push([first_pass[k][0], first_pass[k][1]]);
                        continue;
                    } else if (dfX1 > dfLeftBorderX && dfX1 < 180 && dfX2 === -180 &&
                        k + 1 < first_pass.length &&
                        first_pass[k - 1][0] > dfLeftBorderX && first_pass[k - 1][0] < 180) {
                        poNewLS.push([180, first_pass[k][1]]);
                        k++;
                        poNewLS.push([first_pass[k][0], first_pass[k][1]]);
                        continue;
                    }

                    if (dfX1 < dfRightBorderX && dfX2 > dfLeftBorderX) {
                        // swap dfX1, dfX2
                        var tmpX = dfX1;
                        dfX1 = dfX2;
                        dfX2 = tmpX;
                        // swap dfY1, dfY2
                        var tmpY = dfY1;
                        dfY1 = dfY2;
                        dfY2 = tmpY;
                    }
                    if (dfX1 > dfLeftBorderX && dfX2 < dfRightBorderX) {
                        dfX2 += 360;
                    }

                    if (dfX1 <= 180 && dfX2 >= 180 && dfX1 < dfX2) {
                        var dfRatio = (180 - dfX1) / (dfX2 - dfX1);
                        var dfY = dfRatio * dfY2 + (1 - dfRatio) * dfY1;
                        poNewLS.push([first_pass[k - 1][0] > dfLeftBorderX ? 180 : -180, dfY]);
                        poNewLS = [];
                        poNewLS.push([first_pass[k - 1][0] > dfLeftBorderX ? -180 : 180, dfY]);
                        poMulti.push(poNewLS);
                    } else {
                        poNewLS = [];
                        poMulti.push(poNewLS);
                    }
                    poNewLS.push([dfX0, first_pass[k][1]]);
                } else {
                    poNewLS.push([first_pass[k][0], first_pass[k][1]]);
                }
            }
        } else {
            // add normally
            var poNewLS0: any = [];
            poMulti.push(poNewLS0);
            for (var l = 0; l < first_pass.length; ++l) {
                poNewLS0.push([first_pass[l][0], first_pass[l][1]]);
            }
        }

        var arc = new Arc(this.properties);
        for (var m = 0; m < poMulti.length; ++m) {
            var line = new LineString();
            arc.geometries.push(line);
            var points = poMulti[m];
            for (var j0 = 0; j0 < points.length; ++j0) {
                line.move_to(points[j0]);
            }
        }
        return arc;
    };

}

const arcMath = {
    Coord: Coord,
    Arc: Arc,
    GreatCircle: GreatCircle
};


//////////////////////////////////////////////////


export interface ImportFlightType {
    date: string,
    from: string,
    to: string,
    trip?: string,
    leg?: string,
    departureTime?: string,
    arrivalTime?: string,
    airline?: string,
    code?: string,
    model?: string,
    plane?: string,
    seat?: string,
    comment?: string,
    purpose?: string,
    class?: string,
    noDay?: string,
    noYear?: string
}

export const LEGS = [
    {value: 'a1', label: 'Away 1st'},
    {value: 'a2', label: 'Away 2nd'},
    {value: 'a3', label: 'Away 3rd'},
    {value: 'a4', label: 'Away 4th'},
    {value: 'b1', label: 'Back 1st'},
    {value: 'b2', label: 'Back 2nd'},
    {value: 'b3', label: 'Back 3rd'},
    {value: 'b4', label: 'Back 4th'},
    {value: 'a5', label: 'Away 5th'},
    {value: 'a6', label: 'Away 6th'},
    {value: 'a7', label: 'Away 7th'},
    {value: 'a8', label: 'Away 8th'},
    {value: 'a9', label: 'Away 9th'},
    {value: 'b5', label: 'Back 5th'},
    {value: 'b6', label: 'Back 6th'},
    {value: 'b7', label: 'Back 7th'},
    {value: 'b8', label: 'Back 8th'},
    {value: 'b9', label: 'Back 9th'},
];

export const PURPOSES = [
    {value: 'leisure', label: 'Leisure'},
    {value: 'business', label: 'Business'},
    {value: 'crew', label: 'Crew'},
    {value: '', label: '-'},
];

export const CLASSES = [
    {value: 'first', label: 'First'},
    {value: 'business', label: 'Business'},
    {value: 'economy premium', label: 'Economy premium'},
    {value: 'economy', label: 'Economy'},
    {value: 'crew', label: 'Crew'},
    {value: '', label: '-'},
];


function checkDuplicateFlight(newFlight: NewFlightType) {
    if (!newFlight.departure) {
        return false;
    }
    // @ts-ignore
    const flights: FlightType[] = store.getState().reducer.allFlights;
    const found = flights.find(flight => {
        return flight.departure && flight.date === newFlight.date.toISODate() && flight.departure.hour === newFlight.departure!.hour && flight.from === newFlight.from && flight.to === newFlight.to
    });
    return found;
}



function getLegRoute(flights: FlightType[], trip: number, leg: string) {
    const match = flights.find(flight => flight.trip === trip && flight.leg === leg);
    if (match) {
        return match.from + '-' + match.to;
    } else {
        return '';
    }
}

function sameTimestamp(date: NullableType<Date>, timestamp: string) {
    if (!date || !timestamp) {
        return false;
    } else {
        return DateTime.fromISO(date.toISOString()).toMillis() === DateTime.fromISO(timestamp).toMillis();
    }
}

function isSameDay(a: DateTime, b: DateTime): boolean {
    log('issameday', a, b);
    return a.hasSame(b, "day") && a.hasSame(b, "month") && a.hasSame(b, "year");
}

function getTripNumbers(flights: FlightType[]): number[] {
    // @ts-ignore
    const numbers = [...new Set(flights.map(flight => flight.trip).filter(number => number))];
    // @ts-ignore
    return numbers;
}

export interface TripDetails {
    startDate: string;
    start: string;
    end: string;
}

function getTripDetails(trip: number): TripDetails {
    // @ts-ignore
    const allFlights: FlightType[] = store.getState().reducer.allFlights;
    if (trip < 0 || allFlights.length === 0) {
        return {
            startDate: 'N/A',
            start: 'N/A',
            end: 'N/A'
        };
    }
    const tripFlights = allFlights.filter(flight => flight.trip === trip);
    if (tripFlights.length === 0) {
        return {
            startDate: 'N/A',
            start: 'N/A',
            end: 'N/A'
        };
    }
    const startDate = tripFlights[0].date;
    const start = tripFlights[0].from;
    let end = 'N/A';
    const awayFlights = tripFlights.filter(flight => flight.leg[0] === 'a');
    awayFlights.forEach(flight => {
        end = flight.to;
    });
    return {
        startDate,
        start,
        end
    };
}

// @ts-ignore
function log(...message) {
    if (process.env.NODE_ENV === 'development') {
        //const stack = new Error().stack;
        //const line = stack.split('\n')[2];
        console.log(...message/*, line*/);
    }
}

function rotateArray(arr: any[], k: number) {
    for (let i = 0; i < k; i++) {
        arr.push(arr.shift());
    }
    return arr;
}


/**
 * Expects flights to be sorted by date in ascending order
 */


function getCityAndCountry(location: Location) {
    return location.city + ',' + location.country;
}

function getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    //var radlon1 = Math.PI * lon1/180;
    //var radlon2 = Math.PI * lon2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    return parseInt('' + dist, 10);
}
/*
function navigateToSilver() {
    window.location.href = 'https://flightlogmap-backend.firebaseapp.com/api/v1/buysilver';
}
function navigateToGold() {
    window.location.href = 'https://flightlogmap-backend.firebaseapp.com/api/v1/buygold';
}
*/
export interface MapEntry {
    attribution: string,
    url: string,
    color: ArcColor,
    opacity: number,
    zoomFactor: number,
    heatColor: any
}

export interface ArcColor {
    base: string,
    highlight: string
}

export const ARC_WHITE = {base: '#ffffff', highlight: '#ff88ff'};
export const ARC_DARK = {base: '#999999', highlight: '#ff88ff'};
export const ARC_MEDIUM = {base: '#8f792d', highlight: '#ff88ff'};
export const ARC_BLUE = {base: '#4488ff', highlight: '#ff88ff'};
export const ARC_OTHER = {base: '#c0a96d', highlight: '#ff88ff'};
export const ARC_17 = {base: '#9DAD6F', highlight: '#ff88ff'};
export const ARC_18 = {base: '#5F634F', highlight: '#ff88ff'};


export const OPACITY_DIMMEST = 0.25;
export const OPACITY_DIM = 0.4;
export const OPACITY_BRIGHT = 0.7;
export const OPACITY_BRIGHTEST = 0.9;

export const HEATCOLOR_GREEN = {0: 'darkgreen', 0.5: 'lime', 1: 'white'};
export const HEATCOLOR_YELLOW = {0: 'black', 0.4: 'yellow', 1: 'white'};
export const HEATCOLOR_ORANGE = {0: 'black', 0.4: 'orange', 1: 'white'};
export const HEATCOLOR_DARKVIOLET = {0: 'black', 0.4: 'darkviolet', 1: 'white'};
export const HEATCOLOR_CHARTREUSE = {0: 'black', 0.4: 'chartreuse', 1: 'white'};
export const HEATCOLOR_MEDIUMPURPLE = {0: 'black', 0.4: 'mediumpurple', 1: 'white'};
export const HEATCOLOR_PALEVIOLETRED = {0: 'black', 0.4: 'palevioletred', 1: 'white'};
export const HEATCOLOR_DARKKHAKI = {0: 'black', 0.4: 'darkkhaki', 1: 'white'};
export const HEATCOLOR_OLIVE = {0: 'black', 0.4: 'olive', 1: 'white'};
export const HEATCOLOR_YELLOWGREEN = {0: 'black', 0.4: 'yellowgreen', 1: 'white'};

function mapData(): Array<MapEntry> {
    return [
        {
            attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>',
            url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 1,
            heatColor: HEATCOLOR_GREEN
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 1,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
            url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 2,
            heatColor: HEATCOLOR_DARKVIOLET
        },
        {
            attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: "https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg",
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHTEST,
            zoomFactor: 3,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>',
            url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 3,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; Source: US National Park Service',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 4,
            heatColor: HEATCOLOR_CHARTREUSE
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 5,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
            color: ARC_DARK,
            opacity: OPACITY_DIM,
            zoomFactor: 6,
            heatColor: HEATCOLOR_MEDIUMPURPLE
        },
/*        {
            attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHTEST,
            zoomFactor: 7,
            heatColor: HEATCOLOR_ORANGE
        }, */
        {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHTEST,
            zoomFactor: 8,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
            color: ARC_DARK,
            opacity: OPACITY_DIM,
            zoomFactor: 9,
            heatColor: HEATCOLOR_PALEVIOLETRED
        },
        {
            attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}{r}.png',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 10,
            heatColor: HEATCOLOR_CHARTREUSE
        },
        {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png',
            color: ARC_DARK,
            opacity: OPACITY_DIM,
            zoomFactor: 11,
            heatColor: HEATCOLOR_DARKKHAKI
        },
        {
            attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.png',
            color: ARC_MEDIUM,
            opacity: OPACITY_DIM,
            zoomFactor: 12,
            heatColor: HEATCOLOR_OLIVE
        },
/*        {
            attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            url: 'https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png',
            color: ARC_BLUE,
            opacity: OPACITY_DIM,
            zoomFactor: 13
        },
        {
            attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            color: ARC_DARK,
            opacity: OPACITY_DIM,
            zoomFactor: 14
        },
        {
            attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png',
            color: ARC_DARK,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 15
        },*/
        {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHTEST,
            zoomFactor: 16,
            heatColor: HEATCOLOR_DARKKHAKI
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
            color: ARC_17,
            opacity: OPACITY_DIM,
            zoomFactor: 17,
            heatColor: HEATCOLOR_OLIVE
        },
        {
            attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
            color: ARC_18,
            opacity: OPACITY_DIMMEST,
            zoomFactor: 18,
            heatColor: HEATCOLOR_YELLOWGREEN
        },
        {
            attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png',
            color: ARC_WHITE,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 19,
            heatColor: HEATCOLOR_YELLOW
        },
        {
            attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-background/{z}/{x}/{y}{r}.png',
            color: ARC_OTHER,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 20,
            heatColor: HEATCOLOR_ORANGE
        },
        {
            attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>',
            url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
            color: ARC_DARK,
            opacity: OPACITY_BRIGHT,
            zoomFactor: 3,
            heatColor: HEATCOLOR_YELLOW
        },
    ];
}

export {
    normalizeFlight,
    getAirports,
    getAirlines,
    getModels,
    callLogin,
    airportToCityCountry,
    GeocodeAddress,
    getContinent,
    getContinentCodes,
    getCountryCodeByCountry,
    getTemp,
    getAirlineImages,
    getCityImages,
    Loader,
    getPlaneImages,
    toAirportCity,
    getCityAndCountry,
    getBasicNameByModelName,
    //getTimeZone,
    arcMath,
    log,
    searchAirport,
    getCountryByCode,
    getUserDataFromBackend,
    getUserDataFromSaveFile,
    airportToCityCountryContinent,
    getFlightsByRoute,
    getAirportsByCity,
    getClimateByCity,
    cityCountryContinentToLocation,
    getPlanePicKey,
    getDistance,
    mapData,
    saveSettings,
    sendMail,
    recaptchaCall,
    getMeasurements,
    addAirline,
    clearAirlinesCache,
    timeStringToTimeType,
    timeStringToTimePickerValue,
    timeTypeToString,
    estimateDuration,
    hoursFromTotalMinutes,
    minutesFromTotalMinutes,
    getContinentNameFromCode,
    convertLatLngValueToClimateQueryValue,
    getTimezoneName,
    getCachedTimezoneName,
    fillCacheWithTimezones,
    logoutBackend,
    convertTemp,
    convertDistance,
    getDistanceUnit,
    checkEmail,
    checkPassword,
    callRegister,
    isDemo,
    demoCounter,
    userLevelAtLeast,
    userLevelAtLeastPure,
    getAllFlightsLength,
    getLocations,
    parseTimeType,
    checkDuplicateFlight,
    sortAndSetFlights,
    hasMultipleAirports,
    toAirportName,
    isFreeUser,
    //navigateToSilver,
    //navigateToGold,
    userLevelNumberPure,
    levelNumber,
    callResend,
    countUsers,
    getExportData,
    basicEncrypt,
    rotateArray,
    resetPassword,
    callReset,
    getTripNumbers,
    getTripDetails,
    sameTimestamp,
    isSameDay,
    getLegRoute,
    getMobileHeightForTable,
    toAirportCityCountry
};
